// extracted by mini-css-extract-plugin
export default {"allButtons":"AddProduct_allButtons__zBUO7","radioBtnPricePerUnitOrBox":"AddProduct_radioBtnPricePerUnitOrBox__IONFm"};